// Studio Workspace Inc 1 — /admin/studio: the studio hub dashboard in the admin
// AppShell (parity with /creator/studio). Shared component; see
// features/live/StudioDashboard.
import { createFileRoute } from '@tanstack/react-router';

import { StudioDashboard } from '@/features/live/StudioDashboard';

export const Route = createFileRoute('/admin/studio')({
  component: StudioDashboard,
});
